export default (object: object | undefined): boolean =>
    object ? Object.keys(object).length === 0 && object.constructor === Object : true
